import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../src/core/api/axiosClient";

const initialState: any = {
  locationSites: [],
  isLoadingLocationSites: false,
  sitesByTCCode: [],
  filterSitesByTCCode: [],
  isLoadingFilterSitesByTCCode: [],
  isLocationSitesByTCCode: false,
  locationSiteDetails: {},
  isLoadingLocationSiteDetails: false,
  isLoading: false,
  error: null,
  isLoadingUnassignedSites: false,
  unassigneSites: [],
};

export const getLocationSites: any = createAsyncThunk(
  "content/getLocationSites",
  async ({ PageNumber, pageSize, searchText, SortBy, SortDirection }: any) => {
    const res = await axios.get(`/slpapp/Site/getall`, {
      params: { PageNumber, pageSize, searchText, SortBy, SortDirection },
    });

    const data = await res.data;
    return data;
  }
);

export const getLocationSiteByCode: any = createAsyncThunk(
  "content/getLocationSiteByCode",
  async ({ siteCode }: any) => {
    const res = await axios.get(`/slpapp/Site/sitebycode`, {
      params: { siteCode },
    });

    const data = await res?.data?.data;
    return data;
  }
);

export const addSite: any = createAsyncThunk(
  "content/addSite",
  async ({ payload }: any) => {
    const res = await axios.post(`/slpapp/Site`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await res.data;
    return data;
  }
);

export const editSite: any = createAsyncThunk(
  "content/editSite",
  async ({ payload, siteCode }: any) => {
    const res = await axios.put(`/slpapp/Site`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
      params: { siteCode },
    });

    const data = await res.data;
    return data;
  }
);

export const deleteSite: any = createAsyncThunk(
  "content/deleteSite",
  async ({ siteCode }: any) => {
    const res = await axios.delete(`/slpapp/Site`, {
      params: { siteCode },
    });

    const data = await res.data.data;
    return data;
  }
);

export const getSiteByTCCode: any = createAsyncThunk(
  "content/getSiteByTCCode",
  async ({ tcCode = "" }: any) => {
    const res = await axios.get(`/slpapp/Site/byTCcode`, {
      params: { tcCode },
    });
    const data = await res?.data;
    return data;
  }
);

export const getFilterSiteByTCCode: any = createAsyncThunk(
  "content/getFilterSiteByTCCode",
  async ({ tcCode = "" }: any) => {
    const res = await axios.get(`/slpapp/Site/byTCcode`, {
      params: { tcCode, isWithAsset: true },
    });
    const data = await res?.data;
    return data;
  }
);

export const getAllUnAssignedSite: any = createAsyncThunk(
  "content/getAllUnAssignedSite",
  async ({ tcCode, supplierId }: any) => {
    const res = await axios.get(`/slpapp/Site/allUnAssignedSite`, {
      params: { tcCode, supplierId },
    });

    const data = await res?.data;
    return data;
  }
);

export const locationSiteSlice = createSlice({
  name: "locationSite",
  initialState,
  reducers: {
    setSiteOptionsData(state, action) {
      state.sitesByTCCode = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getLocationSites.pending, (state) => {
      state.isLoadingLocationSites = true;
    });
    builder.addCase(getLocationSites.fulfilled, (state, action) => {
      state.isLoadingLocationSites = false;
      state.locationSites = action.payload;
    });
    builder.addCase(getLocationSites.rejected, (state, action) => {
      state.isLoadingLocationSites = false;
      state.error = action.error.message;
    });

    builder.addCase(getLocationSiteByCode.pending, (state) => {
      state.isLoadingLocationSiteDetails = true;
    });
    builder.addCase(getLocationSiteByCode.fulfilled, (state, action) => {
      state.isLoadingLocationSiteDetails = false;
      state.locationSiteDetails = action.payload;
    });
    builder.addCase(getLocationSiteByCode.rejected, (state, action) => {
      state.isLoadingLocationSiteDetails = false;
      state.error = action.error.message;
    });

    builder.addCase(addSite.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(addSite.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(addSite.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(deleteSite.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(deleteSite.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(deleteSite.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(editSite.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(editSite.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(editSite.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(getSiteByTCCode.pending, (state) => {
      state.isLocationSitesByTCCode = true;
    });
    builder.addCase(getSiteByTCCode.fulfilled, (state, action) => {
      state.isLocationSitesByTCCode = false;
      state.sitesByTCCode = action.payload;
    });
    builder.addCase(getSiteByTCCode.rejected, (state, action) => {
      state.isLocationSitesByTCCode = false;
      state.error = action.error.message;
    });

    builder.addCase(getFilterSiteByTCCode.pending, (state) => {
      state.isLoadingFilterSitesByTCCode = true;
    });
    builder.addCase(getFilterSiteByTCCode.fulfilled, (state, action) => {
      state.isLoadingFilterSitesByTCCode = false;
      state.filterSitesByTCCode = action.payload;
    });
    builder.addCase(getFilterSiteByTCCode.rejected, (state, action) => {
      state.isLoadingFilterSitesByTCCode = false;
      state.error = action.error.message;
    });

    builder.addCase(getAllUnAssignedSite.pending, (state) => {
      state.isLoadingUnassignedSites = true;
    });
    builder.addCase(getAllUnAssignedSite.fulfilled, (state, action) => {
      state.isLoadingUnassignedSites = false;
      state.unassigneSites = action.payload;
    });
    builder.addCase(getAllUnAssignedSite.rejected, (state, action) => {
      state.isLoadingUnassignedSites = false;
      state.error = action.error.message;
    });
  },
});

export const { setSiteOptionsData } = locationSiteSlice.actions;

export default locationSiteSlice.reducer;
